var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94444 15.1667L11.5556 19.5L16.6111 13L23.1111 21.6667H2.88889L7.94444 15.1667ZM26 23.1111V2.88889C26 1.28556 24.7 0 23.1111 0H2.88889C2.12271 0 1.38791 0.304364 0.846136 0.846136C0.304364 1.38791 0 2.12271 0 2.88889V23.1111C0 23.8773 0.304364 24.6121 0.846136 25.1539C1.38791 25.6956 2.12271 26 2.88889 26H23.1111C23.8773 26 24.6121 25.6956 25.1539 25.1539C25.6956 24.6121 26 23.8773 26 23.1111Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIconBlack);
export default __webpack_public_path__ + "static/media/image-icon-black.0f76cac6da26123b6fdc7ad5761e4383.svg";
export { ForwardRef as ReactComponent };